module.exports = __webpack_public_path__ + "static/img/arrow-circle.c244d0d.png";